import React from "react";
import PropTypes from "prop-types";
import SelectExtended from "components/custom/forms/select-extended";
import { Form } from "react-bootstrap";
import { isEqual } from "lodash";

class DraftFiltersItem extends React.Component {
    shouldComponentUpdate(nextProps) {
        if (nextProps.label !== this.props.label) {
            return true;
        } else if (nextProps.isMulti !== this.props.isMulti) {
            return true;
        } else if (!isEqual(nextProps.filterObj, this.props.filterObj)) {
            return true;
        } else if (!isEqual(nextProps.valuesObj, this.props.valuesObj)) {
            return true;
        }
        return false;
    }

    render() {
        const {
            onChange,
            filterObj,
            valuesObj
        } = this.props;

        let filterOptions = [];
        if (typeof filterObj === "object") {
            const filterIsArray = Array.isArray(filterObj);
            filterOptions = Object.keys(filterObj)
                .map((id) => ({
                    label: filterObj[id] === null || filterObj[id] === "" ? "-" : filterObj[id],
                    value: filterIsArray ? filterObj[id] : id,
                    className: "select-option"
                }))
                .sort((a, b) => {
                    // eslint-disable-next-line no-restricted-globals
                    if (isNaN(parseInt(a.label, 10))) {
                        if (a.label.toLowerCase() > b.label.toLowerCase()) {
                            return 1;
                        } else if (a.label.toLowerCase() < b.label.toLowerCase()) {
                            return -1;
                        }
                        return 0;
                    } else {
                        if (parseInt(a.label, 10) > parseInt(b.label, 10)) {
                            return 1;
                        } else if (parseInt(a.label, 10) < parseInt(b.label, 10)) {
                            return -1;
                        }
                        return 0;
                    }
                });
        }

        return (
            <Form.Group className="mb-1 draft-filter-wrapper">
                <Form.Label className="mb-0 font-weight-bold">{this.props.label}</Form.Label>
                <div className="d-block">
                    <SelectExtended
                        options={filterOptions}
                        isLoading={false}
                        isClearable={this.props.isClearable}
                        isSearchable={true}
                        isMulti={this.props.isMulti}
                        value={valuesObj}
                        onChange={item => onChange(item)}
                        className="filter-select"
                        classNamePrefix="filter-select"
                    />
                </div>
            </Form.Group>
        );
    }
}

DraftFiltersItem.defaultProps = {
    isClearable: true
};

DraftFiltersItem.propTypes = {
    label: PropTypes.string.isRequired,
    filterObj: PropTypes.oneOfType([PropTypes.object, PropTypes.array]).isRequired,
    valuesObj: PropTypes.any.isRequired,
    isMulti: PropTypes.bool.isRequired,
    onChange: PropTypes.func.isRequired,
    isClearable: PropTypes.bool
};

export default DraftFiltersItem;
